module.exports = __webpack_public_path__ + "img/spring_trip-20160416-18.8d1dba12.jpg";